import { useNavigate } from 'react-router-dom';
import Button from '../button/Button';
import { useUserAgent } from 'src/common/userAgent/useUserAgent';
import { wfNavigate } from '../../router/WfScreenRegistration';
import { WfScreensMap } from '../../router/WfScreensMap';
import { WF_Screen } from '../../router/WfScreens';
import { useTranslation } from 'react-i18next';

function WF_GeneralMenu() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const userAgent = useUserAgent();

  const handleShowMaps = () => {
    wfNavigate(navigate, WfScreensMap[WF_Screen.PropertiesMap].path);
  };

  const handleShowList = () => {
    wfNavigate(navigate, WfScreensMap[WF_Screen.PropertiesList].path);
  };

  const handleShowDataSummary = () => {
    wfNavigate(navigate, WfScreensMap[WF_Screen.BranchSummary].path);
  };

  return (
    <section
      className="mt-4 rounded-lg border border-green-400 bg-green-100 p-4"
      aria-labelledby="general-menu-title"
    >
      <h2 id="general-menu-title" className="mb-4 text-lg font-bold">
        {t('wf.menu.generalMenutitle')}
      </h2>
      <div className="flex flex-col space-y-3">
        <Button title={t('wf.menu.showMaps')} onClick={handleShowMaps} />
        <Button title={t('wf.menu.showList')} onClick={handleShowList} />
        {userAgent.isDesktop && (
          <Button title={t('wf.menu.showDataSummary')} onClick={handleShowDataSummary} />
        )}
      </div>
    </section>
  );
}

export default WF_GeneralMenu;
